import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Generico } from "../../components/Generico";
import { Consecuencia } from "../../models/riesgo/Consecuencia";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { InputComponent } from "../../components/InputComponent";
import { Panel } from "primereact/panel";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";

export const ConsecuenciasGeneral = ({ permss, toast, generic, riesgo, tipo, funcionalidades = [] }) => {
    const omodel = new Consecuencia();
    const matrizSrv = new MonitoreoService();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model, null);
    const [registros, setRegistros] = useState(null);
    const [item, setItem] = useState(null);
    const [load, setLoad] = useState(false);
    const [dialogConsecuencia, setDialogConsecuencia] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { table, setLoading, setTotalRecords, lazyParams, inArea, inText, inNumber } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams, tipo]);

    const configuracionPorTipo = {
        MTR_RIESGO_CONSECUENCIA: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-PROBABILIDAD'
        },
        MTR_RIESGO_PROBABILIDAD: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-PROBABILIDAD'
        },
        MTR_RIESGO_CSC_RIESGO_CONTAGIO: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-CSC-RIESGO-CONTAGIO'
        },
        MTR_RIESGO_CSC_LEGAL: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-CSC-LEGAL'
        },
        MTR_RIESGO_CSC_OPERATIVO: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-CSC-OPERATIVO'
        },
        MTR_RIESGO_CSC_REPUTACIONAL: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-CSC-REPUTACIONAL'
        },
        MTR_RIESGO_RANQUEO: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-RANQUEO'
        },
        MTR_RIESGO_TIPO_CONTROL: {
            campos: ['orden', 'nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-TIPO-CONTROL'
        },
        MTR_RIESGO_EJECUCION_CONTROL: {
            campos: ['orden', 'nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-EJECUCION'
        },
        MTR_RIESGO_FRECUENCIA_CONTROL: {
            campos: ['orden', 'nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-FRECUENCIA'
        },
        MTR_RIESGO_SOLIDEZ_CONTROL: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-SOLIDEZ'
        },
        MTR_RIESGO_EFECTIVIDAD_CONTROL: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-EFECTIVIDAD'
        },
        DEFAULT: {
            campos: ['descripcion'],
            funcionalidad: null
        }
    };

    const tiposSiempreEditables = [
        'MTR_RIESGO_PROBABILIDAD',
        'MTR_RIESGO_CSC_RIESGO_CONTAGIO',
        'MTR_RIESGO_CSC_LEGAL',
        'MTR_RIESGO_CSC_OPERATIVO',
        'MTR_RIESGO_CSC_REPUTACIONAL',
        'MTR_RIESGO_RANQUEO',
    ];

    const camposPermitidos = configuracionPorTipo[tipo]?.campos ?? configuracionPorTipo.DEFAULT.campos;
    const funcionalidadRequerida = configuracionPorTipo[tipo]?.funcionalidad;

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.tipo = tipo;
        _lazyParams.matrizId = riesgo?.id;
        matrizSrv.listado('matriz-riesgo-consecuencia/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
        }).finally(() => setLoading(false));
    };

    const onSubmit = (data) => {
        data.tipo = tipo;
        data.matrizId = riesgo?.id;
        const esNuevo = getValues('id') == null;
        const endpoint = esNuevo ? 'matriz-riesgo-consecuencia/nuevo' : 'matriz-riesgo-consecuencia/editar';
        const servicio = esNuevo ? matrizSrv.nuevo : matrizSrv.editar;
        setLoad(true);
        servicio(data, endpoint).then(res => {
            generic.funcSuccess(res, toast);
            setDialogConsecuencia(false);
            loadLazyData();
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => setLoad(false));
    };

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && siOpcion(funcionalidadRequerida))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editar() });
        if (permss?.eliminar && siOpcion(funcionalidadRequerida)) {
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
        }
        return [{ label: 'Opciones', items }];
    };

    const customDialogHeader = () => (
        <div>
            <i className="pi pi-user-edit icon-header" />
            <span className="title-header">
                {getValues('id') == null ? " Nuevo " : " Editar "}
            </span>
        </div>
    );

    const editar = () => {
        matrizSrv.consultar(`${item?.id}/${tipo}`, 'matriz-riesgo-consecuencia/consulta').then(res => {
            const registro = generic.renewValues(res.data, omodel.model);
            reset(registro);
            setDialogConsecuencia(true);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogConsecuencia(true);
    };

    const confirmDelete = () => {
        confirmDialog({
            group: 'eliminar-riesgo',
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    }

    const eliminar = () => {
        matrizSrv.eliminar(`${item?.id}/${tipo}?matrizId=${riesgo.id}`, 'matriz-riesgo-consecuencia/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const headerTemplate = (options) => {
        const puedeCrearTipo = !camposPermitidos?.includes('orden'); // si no se puede modificar el orden, no se puede crear
        if (!siOpcion(funcionalidadRequerida) || puedeCrearTipo) return null;
        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    {permss?.crear && <Button icon="pi pi-plus" className="p-button-rounded p-button-success mr-2" type="button" tooltip="Nuevo" onClick={openNew} />}
                </div>
            </div>
        );
    };

    return (
        <>
            <Panel headerTemplate={headerTemplate}>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Panel>

            <Dialog visible={dialogConsecuencia} header={customDialogHeader} modal className="p-fluid dialog-personalizado" onHide={() => setDialogConsecuencia(false)} style={{ width: '400px' }}         >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {camposPermitidos.includes('orden') &&
                            inNumber('orden', 0, false, { min: omodel.model.orden?.min ?? 1 }, 12)}
                        {camposPermitidos.includes('nivel') && inText('nivel', {}, 12)}
                        {camposPermitidos.includes('descripcion') && inArea('descripcion', 5, 30, 12)}
                    </div>
                    {generic.buttonsForms(setDialogConsecuencia, load)}
                </form>
            </Dialog>
        </>
    );
};
